
import React from 'react';
import { Route } from 'react-router-dom';
import AuthGuard from '@/components/auth/AuthGuard';

// Admin Pages
import AdminDashboard from '@/pages/admin/AdminDashboard';
import AdminAuthors from '@/pages/admin/AdminAuthors';
import AuthorDetail from '@/pages/admin/AuthorDetail';
import AuthorBooks from '@/pages/admin/AuthorBooks';
import AuthorRoyalties from '@/pages/admin/AuthorRoyalties';
import AdminRoyalties from '@/pages/admin/AdminRoyalties';
import RoyaltyReportView from '@/pages/admin/RoyaltyReportView';
import RoyaltyReportEdit from '@/pages/admin/RoyaltyReportEdit';
import AdminPayments from '@/pages/admin/AdminPayments';
import AdminSupportTickets from '@/pages/admin/AdminSupportTickets';
import AdminTicketDetail from '@/pages/admin/AdminTicketDetail';
import AdminBooks from '@/pages/admin/AdminBooks';
import AdminAccountSettings from '@/pages/admin/AdminAccountSettings';

const AdminRoutes = () => {
  return [
    <Route key="admin-dashboard" path="/admin/dashboard" element={
      <AuthGuard allowedRoles={['admin']}>
        <AdminDashboard />
      </AuthGuard>
    } />,
    <Route key="admin-authors" path="/admin/authors" element={
      <AuthGuard allowedRoles={['admin']}>
        <AdminAuthors />
      </AuthGuard>
    } />,
    <Route key="admin-author-detail" path="/admin/authors/:id" element={
      <AuthGuard allowedRoles={['admin']}>
        <AuthorDetail />
      </AuthGuard>
    } />,
    <Route key="admin-author-books" path="/admin/authors/:id/books" element={
      <AuthGuard allowedRoles={['admin']}>
        <AuthorBooks />
      </AuthGuard>
    } />,
    <Route key="admin-author-royalties" path="/admin/authors/:id/royalties" element={
      <AuthGuard allowedRoles={['admin']}>
        <AuthorRoyalties />
      </AuthGuard>
    } />,
    <Route key="admin-books" path="/admin/books" element={
      <AuthGuard allowedRoles={['admin']}>
        <AdminBooks />
      </AuthGuard>
    } />,
    <Route key="admin-royalties" path="/admin/royalties" element={
      <AuthGuard allowedRoles={['admin']}>
        <AdminRoyalties />
      </AuthGuard>
    } />,
    <Route key="admin-royalty-view" path="/admin/royalties/:id" element={
      <AuthGuard allowedRoles={['admin']}>
        <RoyaltyReportView />
      </AuthGuard>
    } />,
    <Route key="admin-royalty-edit" path="/admin/royalties/:id/edit" element={
      <AuthGuard allowedRoles={['admin']}>
        <RoyaltyReportEdit />
      </AuthGuard>
    } />,
    <Route key="admin-payments" path="/admin/payments" element={
      <AuthGuard allowedRoles={['admin']}>
        <AdminPayments />
      </AuthGuard>
    } />,
    <Route key="admin-support" path="/admin/support" element={
      <AuthGuard allowedRoles={['admin']}>
        <AdminSupportTickets />
      </AuthGuard>
    } />,
    <Route key="admin-tickets-alias" path="/admin/tickets" element={
      <AuthGuard allowedRoles={['admin']}>
        <AdminSupportTickets />
      </AuthGuard>
    } />,
    <Route key="admin-ticket-detail" path="/admin/tickets/:id" element={
      <AuthGuard allowedRoles={['admin']}>
        <AdminTicketDetail />
      </AuthGuard>
    } />,
    <Route key="admin-account" path="/admin/account" element={
      <AuthGuard allowedRoles={['admin']}>
        <AdminAccountSettings />
      </AuthGuard>
    } />
  ];
};

export default AdminRoutes;
